import { isNumber } from 'lodash';
import React from 'react';
import { formatColor } from '@meitu/saas-colors';
import { BaseLayerView } from '@/framework';
import { base64Kit } from '@/utils/base64-kit';
import { DynamicType, IBackgroundLayerProps, IRenderLayerProps, StretchOptionType } from '@/version-types';
import './background-layer.less';

const backgroundImageURLMap = {};

const BackgroundLayer: React.FC<IRenderLayerProps> = ({ layer, isNavigator }) => {
    const { width: stageWidth, height: stageHeight } = layer;
    const image = layer.data as IBackgroundLayerProps;
    const { url: backgroundUrl, naturalWidth, naturalHeight, dynamicInfo } = image;
    const url = base64Kit.getLocalUrl(backgroundUrl);

    if (!backgroundImageURLMap[url]) {
        // 浏览器中缓存该url
        backgroundImageURLMap[url] = new Image();
        backgroundImageURLMap[url].src = url;
    }

    const containerStyle = {
        width: stageWidth,
        height: stageHeight,
        background: image.backgroundColor || (formatColor(image?.backgroundGradient || '') as string) || 'transparent',
    };
    const stretchOption = image.stretchOption;
    const ratio = {
        widthRatio: image.imageTransform.widthRatio,
        heightRatio: image.imageTransform.heightRatio,
    };

    const rotate = {
        rotateX: image.imageTransform.flipV ? 180 : 0,
        rotateY: image.imageTransform.flipH ? 180 : 0,
        rotateZ: image.imageTransform.rotate,
    };
    const opacity = isNumber(layer.opacity) ? layer.opacity : 1;
    const scale = image?.imageTransform.scale || 1;
    const offset = {
        offsetX: ~~(image.imageTransform.offsetX * ratio.widthRatio * stageWidth * scale) || 0,
        offsetY: ~~(image.imageTransform.offsetY * ratio.heightRatio * stageHeight * scale) || 0,
    };

    if (
        dynamicInfo &&
        !dynamicInfo?.hidden &&
        (dynamicInfo?.dynamicType === DynamicType.CSS || dynamicInfo?.dynamicType === DynamicType.Shader) &&
        !isNavigator
    ) {
        return null;
    }

    return (
        <BaseLayerView layer={layer} disableEvents={true} isNavigator={isNavigator}>
            <div className="app-background-wrap">
                <div style={containerStyle}>
                    {url && (
                        <div
                            className="point-event-none"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: stageWidth,
                                height: stageHeight,
                                transform: `rotateX(${rotate.rotateX}deg) rotateY(${rotate.rotateY}deg) `,
                                backgroundColor: `${
                                    dynamicInfo?.enableBGColor &&
                                    (dynamicInfo?.dynamicType === DynamicType.Video ||
                                        dynamicInfo?.dynamicType === DynamicType.Webp)
                                        ? (layer.data as IBackgroundLayerProps).backgroundColor
                                        : '#fff'
                                }`,
                            }}
                        >
                            {stretchOption === StretchOptionType.repeat ? (
                                <div
                                    id={isNavigator ? '' : `background-${layer.id}`}
                                    style={{
                                        position: 'absolute',
                                        left: '50%',
                                        top: '50%',
                                        transform: `translate(-50%, -50%)`,
                                        width: `${stageWidth * scale}px`,
                                        height: `${stageHeight * scale}px`,
                                        backgroundRepeat: 'repeat',
                                        backgroundImage: `url(${url})`,
                                        backgroundSize: `${naturalWidth}px ${naturalHeight}px`,
                                        backgroundPosition: 'center',
                                        opacity: opacity,
                                    }}
                                />
                            ) : (
                                <div
                                    id={isNavigator ? '' : `background-${layer.id}`}
                                    style={{
                                        position: 'absolute',
                                        left: '50%',
                                        top: '50%',
                                        transform: `translate(-50%, -50%)`,
                                        width: ratio.widthRatio * stageWidth * scale + 'px',
                                        height: ratio.heightRatio * stageHeight * scale + 'px',
                                        pointerEvents: 'none',
                                        flexShrink: 0,
                                        // backgroundColor: '#fff',
                                    }}
                                >
                                    <img
                                        src={url}
                                        alt=""
                                        style={{
                                            width: ratio.widthRatio * stageWidth * scale + 'px',
                                            height: ratio.heightRatio * stageHeight * scale + 'px',
                                            transform: `translateX(${offset.offsetX}px) translateY(${offset.offsetY}px) rotateZ(${rotate.rotateZ}deg)`,
                                            pointerEvents: 'none',
                                            flexShrink: 0,
                                            opacity: opacity,
                                        }}
                                        key={isNavigator ? '' : 'bg-result-result'}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </BaseLayerView>
    );
};
export default React.memo(BackgroundLayer);
